import { menuTabIndexAtom } from '@/components/manage/commons/constants';
import ExecTemplate from '@/templates/ExecTemplate';
import ManageTemplate from '@/templates/ManageTemplate';
import ReportTemplate from '@/templates/ReportTemplate';
import { atom, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { useLocation, useParams } from 'react-router-dom';

export const sidAtom = atom<string>();
export default function PlanContainer() {
  const { mode: pMode, tabIndex } = useParams();

  const location = useLocation();
  const [cookieStatus, setCookieStatus] = useState(false);
  const setSid = useSetAtom(sidAtom);
  const setMenuTabIndex = useSetAtom(menuTabIndexAtom);
  const [mode, setMode] = useState<string>();

  useEffect(() => {
    const queryParam = new URLSearchParams(location.search);
    const connectSid = queryParam.get('connect.sid');
    const cookie = new Cookies();
    cookie.set('connect.sid', connectSid, { path: '/' });
    setCookieStatus(true);
    setSid(connectSid);
    setMode(pMode);
    if (pMode === 'mng') {
      setMenuTabIndex(Number(tabIndex));
    }
  }, [location.search, pMode, tabIndex]);

  return cookieStatus ? (
    <>
      {mode === 'mng' && <ManageTemplate />}
      {mode === 'exec' && <ExecTemplate />}
      {mode === 'rep' && <ReportTemplate />}
    </>
  ) : (
    <></>
  );
}
